var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { UserType } from "healthex-common/user.dtos";
export class BannerUIManager {
    constructor(authManager) {
        this.bannerTimerId = null;
        this.bannerStartTime = null;
        this.remainingTime = null;
        this.banner = null;
        this.isHovered = false;
        this.authManager = authManager;
    }
    clearBanner() {
        if (this.bannerTimerId === null)
            return;
        window.clearTimeout(this.bannerTimerId);
        this.bannerTimerId = null;
    }
    startTimer(duration) {
        this.clearBanner();
        this.bannerStartTime = Date.now();
        this.remainingTime = duration;
        this.bannerTimerId = window.setTimeout(() => {
            if (!this.isHovered) {
                this.banner = null;
                this.bannerStartTime = null;
                this.remainingTime = null;
            }
        }, duration);
    }
    get isPatient() {
        return this.authManager.userType === UserType.PATIENT;
    }
    handleMouseEnter() {
        var _a, _b;
        this.isHovered = true;
        if (this.bannerTimerId !== null) {
            this.clearBanner();
            if (this.bannerStartTime !== null) {
                const elapsedTime = Date.now() - this.bannerStartTime;
                this.remainingTime = Math.max(0, ((_b = (_a = this.banner) === null || _a === void 0 ? void 0 : _a.durationInMS) !== null && _b !== void 0 ? _b : 3000) - elapsedTime);
            }
        }
    }
    handleMouseLeave() {
        this.isHovered = false;
        if (this.banner && this.remainingTime !== null && this.remainingTime > 0) {
            this.startTimer(this.remainingTime);
        }
        else if (this.banner) {
            this.banner = null;
            this.bannerStartTime = null;
            this.remainingTime = null;
        }
    }
    closeBanner() {
        this.clearBanner();
        this.banner = null;
        this.bannerStartTime = null;
        this.remainingTime = null;
    }
    displayBanner(banner) {
        var _a, _b, _c;
        if (banner.ctaCallback) {
            const originalCallback = banner.ctaCallback;
            banner.ctaCallback = () => {
                originalCallback();
                this.closeBanner();
            };
        }
        this.banner = { ...banner, type: (_a = banner.type) !== null && _a !== void 0 ? _a : "SUCCESS", center: (_b = banner.center) !== null && _b !== void 0 ? _b : this.isPatient };
        this.startTimer((_c = banner.durationInMS) !== null && _c !== void 0 ? _c : 3000);
    }
}
__decorate([
    observable
], BannerUIManager.prototype, "banner", void 0);
__decorate([
    observable
], BannerUIManager.prototype, "isHovered", void 0);
